export default __webpack_public_path__ + "static/media/Calvin Zheng.4cc60974.png";